import Vue from 'vue';
import VueRouter from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout';
import Calculator from '../pages/Calculator';
import CurrencyList from '../pages/CurrencyList';
import TopCurrency from '../pages/TopCurrency';
import TopCurrencyText from '../pages/TopCurrencyText';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: DefaultLayout,
    },
    {
        path: '/calculator',
        name: 'calculator',
        component: Calculator,
    },
    {
        path: '/currencies',
        name: 'currencyList',
        component: CurrencyList,
    },
    {
        path: '/topcurrency',
        name: 'topCurrency',
        component: TopCurrency,
    },
    {
        path: '/topcurrencytext',
        name: 'topCurrencyText',
        component: TopCurrencyText,
    },
    {
        path: '*',
        redirect: { name: 'home' },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
